import { useState } from 'react';
import { Waves, Navigation, Binoculars, Map, X, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import MeteoMareeWidget from './MeteoMareeWidget';
import CompassWidget from './CompassWidget';

function openNavAndCo() {
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isAndroid = /Android/.test(ua);

  if (isIOS) {
    const appStoreUrl = 'https://apps.apple.com/app/nav-co/id1642742060';
    const now = Date.now();
    window.location.href = 'navco://';
    setTimeout(() => {
      if (Date.now() - now < 2000) {
        window.open(appStoreUrl, '_blank');
      }
    }, 800);
  } else if (isAndroid) {
    window.location.href = 'intent://#Intent;package=com.navco;scheme=https;S.browser_fallback_url=' +
      encodeURIComponent('https://play.google.com/store/apps/details?id=com.navco') + ';end';
  } else {
    window.open('https://apps.apple.com/app/nav-co/id1642742060', '_blank');
  }
}

const PelagisPanel = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-2 sm:p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl h-[85vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-indigo-600 to-purple-700 text-white flex-shrink-0">
          <div className="flex items-center gap-2">
            <Binoculars className="h-5 w-5" />
            <span className="font-semibold">Observatoire Pelagis</span>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="https://www.observatoire-pelagis.cnrs.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 rounded-lg hover:bg-white/20 transition-colors"
              title="Ouvrir dans un nouvel onglet"
            >
              <ExternalLink className="h-4 w-4" />
            </a>
            <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/20 transition-colors" data-testid="pelagis-close">
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        <iframe
          src="https://www.observatoire-pelagis.cnrs.fr"
          className="flex-1 w-full border-0"
          title="Observatoire Pelagis"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        />
      </div>
    </div>
  );
};

const ZenButton = ({ className = '', showCompass = true }) => {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [isCompassOpen, setIsCompassOpen] = useState(false);
  const [isPelagisOpen, setIsPelagisOpen] = useState(false);

  return (
    <>
      <div className={`flex items-center gap-2 flex-wrap ${className}`}>
        <Button
          onClick={() => setIsWidgetOpen(true)}
          className="bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
          data-testid="zen-button"
        >
          <Waves className="h-4 w-4 mr-2" />
          <span className="hidden sm:inline">Meteo & Marees</span>
          <span className="sm:hidden">Meteo</span>
        </Button>

        {showCompass && (
          <Button
            onClick={() => setIsCompassOpen(true)}
            className="bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
            data-testid="compass-button"
          >
            <Navigation className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Compas</span>
          </Button>
        )}

        <Button
          onClick={() => setIsPelagisOpen(true)}
          className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
          data-testid="pelagis-button"
        >
          <Binoculars className="h-4 w-4 mr-2" />
          <span className="hidden sm:inline">Pelagis</span>
          <span className="sm:hidden">Pelagis</span>
        </Button>

        <Button
          onClick={openNavAndCo}
          className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-lg hover:shadow-xl transition-all duration-300"
          data-testid="navco-button"
        >
          <Map className="h-4 w-4 mr-2" />
          <span className="hidden sm:inline">Nav&Co</span>
          <span className="sm:hidden">Nav&Co</span>
        </Button>
      </div>
      
      <MeteoMareeWidget 
        isOpen={isWidgetOpen} 
        onClose={() => setIsWidgetOpen(false)} 
      />
      <CompassWidget
        isOpen={isCompassOpen}
        onClose={() => setIsCompassOpen(false)}
      />
      <PelagisPanel
        isOpen={isPelagisOpen}
        onClose={() => setIsPelagisOpen(false)}
      />
    </>
  );
};

export default ZenButton;
